import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getDateWithoutTime } from 'components/global/utils';
import { TradesDistrictParams } from '@api/order-reporting/types-deliveries/DeliveriesParams';
import { TradesDistrictReport } from '@api/order-reporting/types-deliveries/DeliveriesReports';
import { TradesDistrictReportGridData } from '@pages/reporting-pages/deliveries-trades-district/types/TradesDistrictReportGridData';
import { convertToGridData } from '@pages/reporting-pages/deliveries-trades-district/store/convertors';
import { DateRange } from '@project-types/DateRange';



interface ReportingDeliveriesTradesDistrictState {
	gridData: TradesDistrictReportGridData[] | null,
	dateRange: DateRange | null,
};

const initialState: ReportingDeliveriesTradesDistrictState = {
	gridData: null,
	dateRange: null,
};



export const reportingDeliveriesTradesDistrictSlice = createSlice({
	name: 'reportingDeliveriesTradesDistrict',
	initialState,
	reducers: {
		createGridData: (state, action: PayloadAction<TradesDistrictReport[] | undefined | null>) => {
			state.gridData = convertToGridData(action.payload);
		},
		setDateRange: (state, action: PayloadAction<DateRange>) => {
			state.dateRange = action.payload;
		},
		setSearchParameters: (state, action: PayloadAction<TradesDistrictParams>) => {
			let stateFrom = state.dateRange ? state.dateRange.from : null;
			let paramFrom = action.payload.dateFrom ? getDateWithoutTime(action.payload.dateFrom) : null;
			let stateTo = state.dateRange ? state.dateRange.to : null;
			let paramTo = action.payload.dateTo ? getDateWithoutTime(action.payload.dateTo) : null;
			if (stateFrom !== paramFrom || stateTo !== paramTo) {
				state.dateRange = paramFrom && paramTo ? { from: paramFrom, to: paramTo } : null;
			}
		},
		resetStore: (_) => initialState,
	},
});



export const {
	createGridData,
	setDateRange,
	setSearchParameters,
	resetStore } = reportingDeliveriesTradesDistrictSlice.actions;